// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlaneDeparture, faPlaneArrival, faUser, faSuitcaseRolling, faTrashAlt, faCheckCircle, faClock, faTrash, faTachometerAlt, faUserCircle, faCar, faTimesCircle, faEdit, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Toasted from 'vue-toasted';

Vue.use(Toasted)

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

library.add(faPlaneDeparture, faPlaneArrival, faUser, faSuitcaseRolling, faTrashAlt, faCheckCircle, faClock, faTrash, faTachometerAlt, faUserCircle, faCar, faTimesCircle, faEdit, faCheck, faTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
  moment,
})

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

import Meta from 'vue-meta'
Vue.use(Meta)

Vue.mixin({
  methods: {
    showToastError: function (error) {
      Vue.toasted.show(error, {
        theme: 'bubble',
        position: 'top-right',
        duration: 3000
      })
    },
    getUser() {
      return store.getters.USER
    },
    meterToMile(meter) {
      return meter * 0.000621371
    },
    b64DecodeUnicode(str) {
      // Going backwards: from bytestream, to percent-encoding, to original string.
      return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    }
  }
})

router.beforeEach((to, from, next) => {
  // console.log('beforeEach')

  if(to.matched.some(record => record.meta.guest)) {
    console.log('guest url')
    next()
    return
  }

  if (!store.getters.USER) {
    console.log('go to login')
    next({
      path: '/login/',
      params: { nextUrl: to.fullPath }
    })
    return
  }

  next()
})

import Axios from 'axios'
Vue.prototype.$http = Axios;
if (store.getters.USER) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'JWT ' + store.getters.USER.token
}


// let vm = new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>',
//   watch: {
//     $route (to, from){
//       $(".left-sidebar #sidebarnav li").click(function() {
//         $(".left-sidebar #sidebarnav li").each(function( index ) {
//           $( this ).removeClass('active');
//         });
//       })


//     }
//   }
// })


// Main Vue Instance
let vm = new Vue({
  el: '#app',
  store,
  router,
  render(h) {
    // Check for standalone route and render directly if true
    if (this.$route.meta && this.$route.meta.standalone) {
      return h(this.$route.matched[0].components.default)
    } else {
      return h(App)
    }
  },
  watch: {
    $route (to, from){
      $(".left-sidebar #sidebarnav li").click(function() {
        $(".left-sidebar #sidebarnav li").each(function( index ) {
          $( this ).removeClass('active');
        });
      })
    }
  }
})

global.vm = vm



// WEBPACK FOOTER //
// ./src/main.js